(() => {
  'use strict';

  const initializeFooter = (root = document) => {
    root.querySelectorAll('[data-reneora-footer]').forEach((footer) => {
      if (footer.dataset.initialized === 'true') return;
      footer.dataset.initialized = 'true';

      const groups = [...footer.querySelectorAll('.rn-footer__group')];
      const mobile = window.matchMedia('(max-width: 599px)');

      const synchronize = () => {
        groups.forEach((group) => {
          group.open = !mobile.matches;
        });
      };

      synchronize();
      mobile.addEventListener?.('change', synchronize);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeFooter());
  } else {
    initializeFooter();
  }

  document.addEventListener('shopify:section:load', (event) => initializeFooter(event.target));
})();
